<template>
	<div
		class="banner-upload"
		v-loading="loading"
		element-loading-text="图片上传中"
		element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.8)">
		<el-tooltip
			effect="dark"
			content="上传成功!"
			placement="top"
			v-model="tooltipShow"
			:manual="true">
			<p></p>
		</el-tooltip>
		<p class="error-msg" v-show="uploadError">上传失败,请重新上传!</p>
		<div class="banner-add el-icon-plus" @click="uploadHandler"></div>
		<!-- <div v-else class="banner-add-disabled el-icon-plus"></div> -->
		<!-- <div v-else class="img-preview-block" @mouseover="imgMouseOver" @mouseout="imgMouseOut">
			<img :src="previewSrc" alt="" class="img-preview" @click="uploadHandler">
			<div class="img-btn" v-show="activeFlag">
				<el-button type="primary" @click="uploadHandler"><i class="el-icon-upload el-icon--right"></i></el-button>
				<el-button type="danger" @click="deleteClick"><i class="el-icon-delete el-icon--right"></i></el-button>
			</div>
		</div> -->
		<input type="file" ref="file" id="file" v-show="false" @change="getFile">
	</div>
</template>

<script>
export default {
	name: 'SellerImgUplaod2',
	props: {
		acountValue: {
			type: String
		}
		// imgSrc: {
		// 	type: String,
		// 	default: ''
		// },
		// location: String,
		// uploadError: Boolean,
		// from: String,
		// imgId: {
		// 	type: String,
		// 	default: '0'
		// },
		// statusIcon: String,
		// hasFile: String,
		// editDisable: {
		// 	type: Boolean,
		// 	default: false
		// },
		// quaEditDisable: {
		// 	type: Boolean,
		// 	default: false
		// }
	},
	data () {
		return {
			previewSrc: '',
			uploadType: new RegExp(/image\/png|image\/jpg|image\/jpeg/),
			uploadTypeText: 'png,jpg,jpeg',
			uploadTypeArr: ['png', 'jpg', 'jpeg', 'rar', 'zip', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'pdf'],
			uploadSize: 5,
			activeFlag: false,
			loading: false,
			tooltipShow: false,
			tooltipTimer: null,
			fileFiles: '',
			uploadError: false
		}
	},
	created () {
		// this.previewSrc = this.imgSrc
		// console.log(this.from)
	},
	watch: {
		// imgSrc (val) {
		// 	this.previewSrc = val
		// 	this.$refs.file.value = ''
		// 	this.$emit('update:uploadError', false)
		// }
	},
	methods: {
		imgMouseOver () {
			if (this.editDisable) {
				this.activeFlag = true
			}
			if (this.quaEditDisable) {
				this.activeFlag = true
			}
		},
		imgMouseOut () {
			this.activeFlag = false
		},
		uploadHandler () {
			this.$refs.file.click()
		},
		getFile (e) {
			this.$emit('update:uploadError', false)
			this.fileFiles = this.$refs.file.files[0]
			let files = e.target.files[0]
			// console.log(files)
			let name = files.name.split('.')[files.name.split('.').length - 1]
			// console.log(name)
			// let type = files.type
			let size = files.size / 1024 / 1024
			// if (!this.uploadType.test(type)) {
			// 	this.$message.error(`上传图片只支持${this.uploadTypeText}格式!`)
			// 	return false
			// }
			if (!this.uploadTypeArr.includes(name)) {
				this.$message.error(`请上传正确的文件格式!`)
				return false
			}
			if (size > this.uploadSize) {
				this.$message.error(`上传文件大小不能超过${this.uploadSize}M!`)
				this.$refs.file.value = ''
				this.previewSrc = ''
				this.$emit('update:imgSrc', '')
				this.$emit('update:hasFile', '0')
				this.$emit('update:uploadError', false)
				return false
			}
			if (!e || !window.FileReader) {
				return false
			}
			let reader = new FileReader()
			reader.readAsDataURL(files)
			reader.onloadend = () => {
				// let image = new Image()
				// image.src = reader.result
				// image.onload = () => {
				this.$refs.file.value = ''
				this.$emit('uploadNewImg', '')
				// }
			}
		},
		deleteClick () {
			if (this.imgId === '0') {
				this.$refs.file.value = ''
				this.previewSrc = ''
				this.$emit('update:imgSrc', '')
				this.$emit('update:hasFile', '0')
				this.$emit('update:uploadError', false)
				return false
			}
			this.$confirm('一经删除无法恢复，是否继续？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				this.deleteHandler()
			}).catch(() => {
			})
		},
		deleteHandler () {
			let param
			let needUrl
			if (this.from) {
				param = {
					dataid: this.imgId,
					deletePath: this.imgSrc
				}
				needUrl = `${this.$fxBaseApi.urlQIVShop}/licenceapply/delimg`
			} else {
				param = {
					id: this.imgId,
					oldurl: this.imgSrc
				}
				needUrl = `${this.$fxBaseApi.urlQIVShop}/goods/delGoodsImg`
			}
			this.$store.dispatch('requestPost', {
				url: needUrl,
				data: param
			}).then(res => {
				if (res.result) {
					if (this.from) {
						this.$message.success(res.msg)
					} else {
						this.$emit('update:imgId', '0')
						this.$message.success('删除成功')
					}
					this.$emit('update:uploadError', false)
					this.$emit('update:imgSrc', '')
					this.$emit('update:hasFile', '0')
					this.previewSrc = ''
					this.$refs.file.value = ''
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		returnSrc () {
			this.$refs.file.value = ''
			this.previewSrc = this.imgSrc
		},
		getCurrentSrc () {
			return this.previewSrc
		},
		hasImgFile () {
			return this.$refs.file.value ? this.location : null
		},
		uploadImgHandler () {
			let needUrl = `${this.$fxBaseApi.urlQIVShop}/upload/adImg`
			return new Promise((resolve, reject) => {
				this.loading = true
				var formData = new FormData()
				formData.append('shopid', sessionStorage.getItem('storeid'))
				formData.append('extension', this.fileFiles.name.split('.')[1])
				formData.append('extension', this.$refs.file.files[0].type)
				formData.append('imgurl', '')
				formData.append('imgname', '')
				formData.append('imgtype', this.imgtype)
				formData.append('imgsort', this.location)
				formData.append('id', this.imgId)
				formData.append('oldurl', this.imgSrc)
				formData.append('file', this.fileFiles)
				this.$store.dispatch('requestFilePost', {
					url: needUrl,
					data: formData
				}).then(res => {
					if (res.result) {
						this.showTooltip()
						this.$emit('update:imgSrc', res.data.url)
						this.$emit('update:imgId', res.data.id)
						this.$emit('update:uploadError', false)
						this.$emit('update:statusIcon', 'submit')
						resolve(res.data)
					} else {
						this.$message.error(res.msg)
						this.$emit('update:uploadError', true)
						reject(res)
					}
				}, error => {
					this.$emit('update:uploadError', true)
					reject(error)
				}).always(() => {
					this.loading = false
				})
			})
		},
		showTooltip () {
			this.tooltipShow = true
			if (this.tooltipTimer) {
				clearTimeout(this.tooltipTimer)
			}
			this.tooltipTimer = setTimeout(() => {
				this.tooltipShow = false
			}, 1500)
		}
	}
}
</script>
<style lang="stylus" scoped>
/deep/.el-loading-mask {
	height: 100px
	margin-top: 20px
	border-radius: 6px;
}
.banner-upload {
	width: 100px;
	height: 100px;
	border-radius: 6px;
	overflow: hidden;
	box-sizing:border-box
	position:relative
	margin-bottom:10px
	margin-right: 20px
	float left
	.error-msg {
		color:red
		position:absolute
		top:0
		left:0
	}
	.banner-add,.img-preview-block {
		border-radius: 6px;
		overflow: hidden;
		box-sizing:border-box
		width: 100px;
		height: 100px;
		line-height: 100px;
		display: inline-block
	}
	.banner-add {
		border: 1px dashed #d9d9d9;
		cursor: pointer;
		position: relative;
		text-align: center;
		font-size: 28px;
		color: #8c939d;
		&:hover {
			border-color: var(--fx-primary-color);
		}
	}
	.banner-add-disabled {
		border-radius: 6px;
		overflow: hidden;
		box-sizing:border-box
		width: 100px;
		height: 100px;
		line-height: 100px;
		display: inline-block
		border: 1px dashed #d9d9d9;
		cursor: not-allowed;
		position: relative;
		text-align: center;
		font-size: 28px;
		color: #8c939d;
	}
	.img-preview-block {
		position:relative
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		.img-preview {
			width:100%
			height:100%
		}
		.img-btn {
			position: absolute
			top:0px
			right:0px
			height:100%
			width:100%
			background-color:rgba(0,0,0,0.1)
			text-align center
		}
	}
}
</style>
